const TailwindSlider = ({
  value,
  max = 100,
  className = "",
  barColor,
}: {
  value: number;
  max?: number;
  className?: string;
  barColor?: string;
}) => {
  const percentage = Math.min(100, Math.max(0, (value / max) * 100));

  // デフォルトのバー色を使用、またはカスタムカラーを適用
  const barStyle = barColor
    ? { width: `${percentage}%`, backgroundColor: barColor }
    : { width: `${percentage}%` };

  return (
    <div className={`w-full h-2 rounded-full overflow-hidden bg-bggray3 ${className}`}>
      <div
        className={`h-full rounded-full transition-all duration-300 ${!barColor ? "bg-bgblue" : ""}`}
        style={barStyle}
      />
    </div>
  );
};

export default TailwindSlider;
